import { LoadingScreen } from 'components';
import { useGlobalSelector } from 'stores';

const LoadingProvider = () => {
  const { loading } = useGlobalSelector();

  return <LoadingScreen loading={loading} />;
};

export { LoadingProvider };
